import React, { useEffect, useRef } from 'react'
import { isDefinedAndNotNull } from '../../utils/functions'

interface FormSubmitterProps<T extends IFormDataBase> {
  url: string | undefined
  formData: T | null | undefined
}

export interface IFormDataBase {
  [key: string]: string
}

function FormSubmitter<T extends IFormDataBase>({
  formData,
  url,
}: FormSubmitterProps<T>) {
  const formRef = useRef<HTMLFormElement>(null)

  useEffect(() => {
    if (formData && formRef.current) {
      formRef.current.submit()
    }
  }, [formData])

  const parseKey = (key: string) => {
    if (key === 'controlData') {
      return key
    }

    return key
      .replace(/\.?([A-Z]+)/g, (_, y) => {
        return '_' + y.toLowerCase()
      })
      .replace(/^_/, '')
  }

  return (
    <>
      {formData && (
        <form
          method="post"
          ref={formRef}
          action={url}
          style={{ display: 'none' }}
        >
          {Object.keys(formData).map(
            (key, i) =>
              isDefinedAndNotNull(formData[key]) && (
                <input
                  name={parseKey(key)}
                  value={formData[key]}
                  key={i}
                  hidden
                  readOnly
                />
              )
          )}
        </form>
      )}
    </>
  )
}

export default FormSubmitter
